import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    title: 'Home',
    canGoBack: false,
    lang: 'id',
    dirId: 0,
  },
  mutations: {
    chTitle(state, title) {
      state.title = title;
    },
    chCGB(state, cgb) {
      state.canGoBack = cgb;
    },
    chLang(state, lang) {
      state.lang = lang;
    },
    chDirId(state, dirId) {
      state.dirId = dirId;
    },
  },
  actions: {
    chTitle: ({ commit }, title) => {
      commit('chTitle', title);
    },
    chCGB: ({ commit }, canGoBack) => {
      commit('chCGB', canGoBack);
    },
    chLang: ({ commit }, lang) => {
      commit('chLang', lang);
    },
    chDirId: ({ commit }, dirId) => {
      commit('chDirId', dirId);
    },
  },
  getters: {
    // getTitle: state => state.title,
  },
});
